import { AxiosResponse } from 'axios';

import { UDNICK } from '../../../../../service/udnick';
import { IConsultaAgendamentos } from '../../../../../store/ducks/consultaAgendamentos/types';

interface ICD {
  codCdd: number;
  nomeFantasia: string;
  contato: string;
  hrInicioAgendamento: string;
  hrFimAgendamento: string;
}

interface ICdds {
  centrosDistribuicao: ICD[];
}

export interface IDetalheVeiculo {
  tipoCarroceria: string;
  placa: string;
  ano: number;
  ativo: string;
}

export interface IDetalheMotorista {
  nome: string;
  cpf: string;
  telefone: string;
  habilitado: string;
  mopp: boolean;
  ativo: string;
}

export interface IPropsDocumento {
  nuNota: number;
  numNota: number;
  codFornecedor: number;
  codDestinatario: number;
  pesoBruto: number;
  valor: number;
  destinatario: string;
  fornecedor: string;
  observacao: string;
  cidadeOrigem: string;
  qtdVolume: number;
  tipoVolume: string;
  nunotaEmitida: number;
  produto: string;
  nomeCD: string;
  temAnexo: number;
}

export interface IResponse {
  pedidos: IPropsDocumento[];
  total: number;
}

export interface IDetalheAgendamento extends IConsultaAgendamentos {}

export const getCentrosDistribuicao = {
  getCentrosDistribuicao: (codCdd: number): Promise<AxiosResponse<ICdds>> =>
    UDNICK.callService('getCentrosDistribuicao', { codCdd }),
};

export const getDetalheAgendamento = {
  getDetalheAgendamento: (
    codCdd: number,
    codAgendamento: number
  ): Promise<AxiosResponse<IDetalheAgendamento>> =>
    UDNICK.callService('getDetalheAgendamento', { codCdd, codAgendamento }),
};

export const AtualizaStatusAgendamentoServices = {
  atualizaStatusAgendamento: (codAgendamento: number): Promise<AxiosResponse> =>
    UDNICK.callService('atualizaStatusAgendamento', {
      codAgendamento,
    }),
};

export const getPedidosOrdemCarga = {
  getPedidosOrdemCarga: (
    ordemCarga: number,
    codEmp: number,
    parceiros: number[]
  ): Promise<AxiosResponse<IResponse>> =>
    UDNICK.callService('getPedidosOrdemCarga', {
      ordemCarga,
      codEmp,
      parceiros,
    }),
};
